(() => { const og26Root = document.querySelector('.og26'); if (!og26Root) return;
'use strict';
document.addEventListener('click',event=>{
 const open=event.target.closest('[data-open]');
 if(open&&open.dataset.open!=='bag-dialog'){
  const dialog=document.getElementById(open.dataset.open);
  if(dialog instanceof HTMLDialogElement&&!dialog.open)dialog.showModal();
 }
 const close=event.target.closest('[data-close]');
 if(close)close.closest('dialog')?.close();
});
og26Root.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}}));
const film=og26Root.querySelector('#hero-film');
if(film){
 const toggle=og26Root.querySelector('#film-toggle'),sound=og26Root.querySelector('#film-sound');
 const motion=matchMedia('(prefers-reduced-motion: reduce)');
 const sync=()=>{toggle.textContent=film.ended?'もう一度再生 ↻':film.paused?'映像を再生 ▶':'映像を止める Ⅱ';toggle.setAttribute('aria-label',film.paused?'映像を再生する':'映像を停止する');sound.textContent=film.muted?'音を入れる ♫':'音を消す ♫';sound.setAttribute('aria-pressed',String(!film.muted));};
 toggle.addEventListener('click',async()=>{if(film.paused){if(film.ended)film.currentTime=0;try{await film.play();}catch{sync();}}else film.pause();});
 sound.addEventListener('click',async()=>{film.muted=!film.muted;if(film.paused&&!film.muted){try{await film.play();}catch{}}sync();});
 ['play','pause','ended','volumechange','loadedmetadata'].forEach(event=>film.addEventListener(event,sync));
 if(!motion.matches){film.play().catch(sync);}else sync();
 document.addEventListener('visibilitychange',()=>{if(document.hidden)film.pause();});
 if('IntersectionObserver'in window)new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)film.pause();},{threshold:0}).observe(film);
}
const book=og26Root.querySelector('#picturebook');
if(book&&'IntersectionObserver'in window){
 const scenes=[...book.querySelectorAll('.book-scene')],stage=book.querySelector('.book-stage');
 const images=scenes.map((scene,index)=>{const image=scene.querySelector('.scene-image').cloneNode();image.removeAttribute('loading');image.alt='';image.className=index===0?'active':'';stage.append(image);return image;});
 book.classList.add('js-book');
 const setScene=index=>{images.forEach((image,i)=>image.classList.toggle('active',i===index));og26Root.querySelector('#book-current').textContent=String(index+1).padStart(2,'0');};
 let scheduled=false;
 const updateScene=()=>{
  scheduled=false;
  if(book.getBoundingClientRect().bottom<0||book.getBoundingClientRect().top>innerHeight)return;
  let best=0,score=-Infinity;
  scenes.forEach((scene,index)=>{
   const r=scene.querySelector('.scene-text').getBoundingClientRect();
   const visible=Math.max(0,Math.min(r.bottom,innerHeight)-Math.max(r.top,0));
   const value=visible>0?visible:-(Math.abs((r.top+r.bottom)/2-innerHeight*.72));
   if(value>score){best=index;score=value;}
  });
  setScene(best);
 };
 const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(updateScene);}};
 addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);schedule();
}

})();